import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

type Props = {
  title: string;
  disabled: boolean;
  isProcessing?: boolean;
  onClick?: () => void;
  disabledTitle?: string;
};

const SubmitButton: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  disabled,
  isProcessing,
  onClick,
  disabledTitle,
}) => {
  const button = (
    <Button
      type={onClick ? 'button' : 'submit'}
      size="sm"
      disabled={disabled}
      onClick={onClick}
      className="ms-2 d-flex align-items-center">
      {isProcessing && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"></span>
      )}
      <span>{title}</span>
    </Button>
  );

  if (disabled && disabledTitle) {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 0, hide: 0 }}
        overlay={
          <Tooltip id="time-entry-submit-disabled-tooltip">
            {disabledTitle}
          </Tooltip>
        }>
        <span className="d-inline-block">{button}</span>
      </OverlayTrigger>
    );
  }

  return button;
};

export default SubmitButton;
